const RecentActivityBox = ({parentStyle, childStyle, imgSrc, title, time}) => {
    return (<div className={parentStyle}>
        <div className={childStyle}><img src={imgSrc} alt="ac1" /> </div>
        <h5>{title}</h5>
        <p>{time}</p>
    </div>)
}
export default RecentActivityBox;